import { downloadInvoiceFile } from 'api/inventory/api';
import { GraniteButton } from 'components/V2/Button/GraniteButton';
import { DownloadOutline } from 'react-ionicons';

export const InvoiceDownloadButton = ({
  invoiceId,
  fileName,
}: {
  invoiceId: string;
  fileName: string;
}) => {
  const handleDownload = async () => {
    try {
      const blob = await downloadInvoiceFile(invoiceId);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName || 'invoice.pdf';
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Failed to download invoice.');
    }
  };

  return (
    <GraniteButton
      variant="unstyled"
      onClick={handleDownload}
      className="mr-2 gap-2 !border-0 p-0 !font-normal !outline-none group-hover/row:text-button-stroke-ghost-hover group-hover/row:underline"
    >
      <span className="inline-block max-w-[250px] truncate" title={fileName}>
        {fileName}
      </span>
      <span className="invisible -mt-0.5 inline-block group-hover/row:visible">
        <DownloadOutline width="16px" height="16px" color="inherit" />
      </span>
    </GraniteButton>
  );
};
